"use strict";
var configPromise = require('../config').configPromise;
var Api = require('./api');
var AppApi = {

  getLanguages(){
    return configPromise.then(function (config) {
      return Api.get(config.languagesUrl).then(function (langList) {
        return {
          langList: langList.filter((lang) => (config.availableLanguages.indexOf(lang.code) >= 0)),
          defaultLang: config.defaultLanguage
        };
      });
    });
  }

};


module.exports = AppApi;
